import * as React from "react";
import { UitkDialogContent, UitkFullscreenDialog } from "uitk-react-dialog";
import { UitkToolbar } from "uitk-react-toolbar";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import CitiCardModalDialogPopUp from "./CitiCardModalDialogPopUp";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { Viewport, ViewMedium, ViewSmall } from "@shared-ui/viewport-context";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export interface CitiCardModalDialogProps {
  items: EditorialModel[];
}

const CONTENT_ID_COUNT = 8;

const CitiCardModalDialog = (props: CitiCardModalDialogProps) => {
  const { items } = props;
  const [isDialogOpen, dialogActions, CitiCardDialogComponent] = useDialog("dialog-example-4");
  const { formatText } = useLocalization();

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const applyNowText = formatText("grid3.citiDesktopStickybar.applyNow.text");

  return (
    <div className="uitk-type-center all-t-padding-six all-b-padding-twelve">
      <Viewport>
        <ViewSmall>
          <>
            <CitiCardDialogComponent>
              <UitkFullscreenDialog dialogShow={isDialogOpen}>
                <UitkToolbar
                  key="UitkToolbar"
                  navigationContent={{
                    navIconLabel: "Close the dialog",
                    onClick: dialogActions.closeDialog as any,
                  }}
                />
                <UitkDialogContent key="Citi-Card-modal-dialog-content">
                  <p key="Citi-Card-modal-dialog-content-Paragraph">
                    <CitiCardModalDialogPopUp items={items} />
                  </p>
                </UitkDialogContent>
              </UitkFullscreenDialog>
            </CitiCardDialogComponent>
            <UitkLayoutPosition
              position={{ right: "zero", bottom: "zero", left: "zero", zindex: "layer3" }}
              className="uitk-button-floating-action-fixed"
            >
              <UitkScrim type={UitkScrimType.BUTTON}>
                <UitkPrimaryButton isFullWidth size={UitkButtonSize.LARGE} onClick={dialogActions.openDialog as any}>
                  {applyNowText}
                </UitkPrimaryButton>
              </UitkScrim>
            </UitkLayoutPosition>
          </>
        </ViewSmall>
        <ViewMedium />
      </Viewport>
    </div>
  );
};

export default CitiCardModalDialog;
